'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = randomIds;


// Workaround for SSR
// https://github.com/vazco/uniforms/issues/40
// https://github.com/facebook/react/issues/4000
function randomIdsGenerator(prefix) {
    var counter = 0;

    return function () {
        return prefix + '-' + ('000' + (counter++).toString(36)).slice(-4);
    };
}

var randomIdPrefix = randomIdsGenerator('uniforms');

function randomIds() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : randomIdPrefix();

    return randomIdsGenerator(prefix);
}


//////////////////
// WEBPACK FOOTER
// ./~/uniforms/randomIds.js
// module id = 646
// module chunks = 35783957827783 65974612472484